import eventBus from '@/events/eventBus';

export default {
    data: () => ({}),
    mounted() {
        eventBus.on('resize',this.onResize);
        this.onResize(this.$vuetify.breakpoint);
    },
    beforeDestroy() {
        eventBus.off('resize',this.onResize);
    },
    methods: {
        // tslint:disable-next-line
        onResize(args) {
        },
    },
};
